var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-container"},[_c('ZddProfile',{attrs:{"isZdd":_vm.isZdd},on:{"logout":_vm.handleQuit,"toSealManage":_vm.goSealManage,"toSignatureManage":_vm.goSignManage,"toUserInfo":_vm.handleGoInfo,"toCompanyAuth":_vm.handleCompanyAuth,"toHandleAuth":_vm.handleAuth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }